// Configuration des images par défaut
export const DEFAULT_IMAGES = {
    // Images par défaut pour les sessions
    SESSION_PLACEHOLDER: '/assets/images/session-default.svg',
    SESSION_DEFAULT: '/assets/images/session-default.svg',

    // Images par défaut pour les exercices
    EXERCISE_PLACEHOLDER: '/assets/images/exercise-placeholder.jpg',
    EXERCISE_DEFAULT: '/assets/images/exercise-default.jpg',

    // Images par défaut pour les catégories
    CATEGORY_EQUILIBRE: '/assets/images/categories/equilibre.jpg',
    CATEGORY_COORDINATION: '/assets/images/categories/coordination.jpg',
    CATEGORY_MEMOIRE: '/assets/images/categories/memoire.jpg',
    CATEGORY_ATTENTION: '/assets/images/categories/attention.jpg',

    // Images par défaut pour les utilisateurs
    USER_AVATAR: '/assets/images/user-avatar.png',

    // Images par défaut pour les erreurs
    ERROR_IMAGE: '/assets/images/error-image.jpg',
    NOT_FOUND: '/assets/images/not-found.jpg',

    // Images par défaut pour les états
    LOADING_IMAGE: '/assets/images/loading.gif',
    EMPTY_STATE: '/assets/images/empty-state.jpg',
};

// Fonction utilitaire pour obtenir une image par défaut
export const getDefaultImage = (type, fallback = DEFAULT_IMAGES.SESSION_PLACEHOLDER) => {
    return DEFAULT_IMAGES[type] || fallback;
};

// Fonction pour obtenir l'image par défaut selon le type de contenu
export const getContentDefaultImage = (contentType, category = null) => {
    switch (contentType) {
        case 'session':
            return DEFAULT_IMAGES.SESSION_PLACEHOLDER;
        case 'exercise':
            return DEFAULT_IMAGES.EXERCISE_PLACEHOLDER;
        case 'category':
            if (category && DEFAULT_IMAGES[`CATEGORY_${category.toUpperCase()}`]) {
                return DEFAULT_IMAGES[`CATEGORY_${category.toUpperCase()}`];
            }
            return DEFAULT_IMAGES.CATEGORY_EQUILIBRE;
        default:
            return DEFAULT_IMAGES.SESSION_PLACEHOLDER;
    }
};

// Fonction pour valider si une URL d'image est valide
export const isValidImageUrl = (url) => {
    if (!url) return false;
    if (url.startsWith('data:')) return true; // Images en base64
    if (url.startsWith('blob:')) return true; // Images blob
    if (url.startsWith('http://') || url.startsWith('https://')) return true; // URLs externes
    if (url.startsWith('/')) return true; // URLs relatives
    return false;
};

// Fonction pour obtenir l'image finale avec fallback
export const getImageWithFallback = (imageUrl, contentType = 'session', category = null) => {
    if (isValidImageUrl(imageUrl)) {
        return imageUrl;
    }
    return getContentDefaultImage(contentType, category);
};
